import { i18n } from 'i18next';
import { LOCALES } from '../config/locales/locales';

export function useLocaleType(i18n: i18n) {
    const localeType = LOCALES.find((item) => item.shortName === i18n.language);

    return {
        localeType,
    };
}
